import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';

const FiltersByDriver = ({ appliedFilters, cardsFilters, setCardsFilters, onClearFilters }) => {
  // prettier-ignore
  const handleFilterChange = filter => R.compose(
    setCardsFilters,
    R.assoc(filter),
    R.path(['target', 'value'])
  );

  return (
    <>
      <TextField
        fullWidth
        label="Location"
        name="Location"
        onChange={handleFilterChange('location')}
        value={cardsFilters.location}
      />

      <FormControl fullWidth>
        <InputLabel id="filter-status">Status</InputLabel>
        <Select
          label="Status"
          labelId="filter-status"
          onChange={handleFilterChange('status')}
          value={cardsFilters.status}
        >
          <MenuItem value="All">All</MenuItem>
          <MenuItem value="Draft">Draft</MenuItem>
          <MenuItem value="Pending">Pending</MenuItem>
          <MenuItem value="Scheduled">Scheduled</MenuItem>
          <MenuItem value="Warning">Warning</MenuItem>
          <MenuItem value="Completed">Completed</MenuItem>
        </Select>
      </FormControl>

      <TextField
        fullWidth
        label="Date Created"
        name="createdDate"
        onChange={handleFilterChange('createdDate')}
        value={cardsFilters.createdDate}
      />

      <TextField
        fullWidth
        label="Trailer ID"
        name="vaporTightnessCode"
        onChange={handleFilterChange('vaporTightnessCode')}
        value={cardsFilters.vaporTightnessCode}
      />

      <TextField
        fullWidth
        label="PO Number"
        name="poNumber"
        onChange={handleFilterChange('poNumber')}
        value={cardsFilters.poNumber}
      />

      {Boolean(appliedFilters.length) && (
        <Button onClick={onClearFilters} variant="text">
          Clear
        </Button>
      )}
    </>
  );
};

FiltersByDriver.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  cardsFilters: PropTypes.shape({
    createdDate: PropTypes.string,
    location: PropTypes.string,
    poNumber: PropTypes.string,
    status: PropTypes.oneOf(['All', 'COMPLETED', 'DRAFT', 'PENDING', 'SCHEDULED', 'WARNING']),
    vaporTightnessCode: PropTypes.string,
  }).isRequired,
  onClearFilters: PropTypes.func.isRequired,
  setCardsFilters: PropTypes.func.isRequired,
};

export default FiltersByDriver;
